import { ApolloLink, Operation } from '@apollo/client/core';
import { pData, pOperation, pRequest, pResponse, pTimeMs } from '../pretty';
import { isSubscription } from '../utils/operations';

export interface RoundTripLinkOptions {
    enabled?: boolean;
    filter?: (op: Operation) => boolean;
}

export default class RoundTripLink extends ApolloLink {
    public enabled: boolean;
    public filter: (op: Operation) => boolean;

    constructor(options: RoundTripLinkOptions = {}) {
        super((operation, forward) => {
            if (!this.enabled || !this.filter(operation)) {
                return forward(operation);
            }

            operation.setContext({ start: Date.now() });

            console.pretty.debug`${pRequest} ${pOperation(operation)} send.`();

            return forward(operation).map((data) => {
                const time = Date.now() - operation.getContext().start;

                if (isSubscription(operation)) {
                    console.pretty.debug`${pResponse} ${pOperation(
                        operation
                    )} received data ${pData(data)}`();
                } else {
                    console.pretty.debug`${pResponse} ${pOperation(
                        operation
                    )} (took ${pTimeMs(time)})`();
                }

                return data;
            });
        });

        this.enabled = options.enabled ?? true;
        this.filter = options.filter ?? (() => true);
    }

    public enable() {
        this.enabled = true;
    }

    public disable() {
        this.enabled = false;
    }
}
